import { BankAccount } from 'APIs/merchants/merchants.types';
import Modal from 'Components/Modal/Modal';
import { ReactElement } from 'react';

type Props = {
  bankAccount: BankAccount;
  setModalBankAccount: (bankAccount: BankAccount | null) => void;
};

const BankAccountModal = ({ bankAccount, setModalBankAccount }: Props): ReactElement => {
  const handleCancel = () => {
    setModalBankAccount(null);
  };

  return (
    <Modal
      title={'Bank Account Details'}
      cancelBtnText="Close"
      handleCancel={handleCancel}
      handleSubmit={() => {}}
      hideConfirmBtn={true}
      confirmBtnText=""
      large={false}
      testId={'merchant-bank-account-modal'}
    >
      <div className="info">
        <div className="info-row">
          <div className="info-col">Account ID</div>
          <div className="info-col data-col">{bankAccount.accountId}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Account name</div>
          <div className="info-col data-col">{bankAccount.accountName}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Bank name</div>
          <div className="info-col data-col">{bankAccount.bankName ?? '-'}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Account number</div>
          <div className="info-col data-col">
            {'AuBankAccountIdentifier' in bankAccount.identifier
              ? bankAccount.identifier.AuBankAccountIdentifier.accountNumber
              : 'HkBankAccountIdentifier' in bankAccount.identifier
              ? bankAccount.identifier.HkBankAccountIdentifier.accountNumber
              : 'HkUsdBankAccountIdentifier' in bankAccount.identifier
              ? bankAccount.identifier.HkUsdBankAccountIdentifier.accountNumber
              : 'NzBankAccountIdentifier' in bankAccount.identifier
              ? bankAccount.identifier.NzBankAccountIdentifier.accountNumber
              : 'SgBankAccountIdentifier' in bankAccount.identifier
              ? bankAccount.identifier.SgBankAccountIdentifier.accountNumber
              : ''}
          </div>
        </div>
        {'AuBankAccountIdentifier' in bankAccount.identifier && (
          <div className="info-row">
            <div className="info-col">BSB</div>
            <div className="info-col data-col">{bankAccount.identifier.AuBankAccountIdentifier.bsb}</div>
          </div>
        )}
        <div className="info-row">
          <div className="info-col">Currency</div>
          <div className="info-col data-col">{bankAccount.currency}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Primary for currency</div>
          <div className="info-col data-col">{bankAccount.isPrimaryForCurrency ? 'Yes' : 'No'}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Country</div>
          <div className="info-col data-col">{bankAccount.country}</div>
        </div>
        <div className="info-row">
          <div className="info-col">Blocked</div>
          <div className="info-col data-col">{bankAccount.isBlocked ? 'Yes' : 'No'}</div>
        </div>
        {bankAccount.isBlocked && (
          <div className="info-row">
            <div className="info-col">Blocked reason</div>
            <div className="info-col data-col">{bankAccount.blockReason ?? '-'}</div>
          </div>
        )}
        <div className="info-row">
          <div className="info-col">Reference account ID</div>
          <div className="info-col data-col">{bankAccount.referenceAccountId ?? '-'}</div>
        </div>
      </div>
    </Modal>
  );
};

export default BankAccountModal;
